// Broker-specific name for the package tracking number. The data field
// stays `hawbNumber` everywhere — only the user-facing label changes:
// Malca's paperwork calls it the Receipt No., Ferrari's the Order No.
export function hawbLabel(job) {
  const names = `${job?.brokerName || ""} ${job?.dispatcherName || ""}`.toLowerCase();
  if (names.includes("malca")) return "Receipt No.";
  if (names.includes("ferrari")) return "Order No.";
  return "HAWB";
}

// "#" form for column headers / field labels. "Receipt No." and
// "Order No." already say "number", so only HAWB gets the "#".
export function hawbNumLabel(job) {
  const label = hawbLabel(job);
  return label === "HAWB" ? "HAWB #" : label;
}

// Phone keyboard hint for the number input. Malca receipt numbers are
// all digits, so show the numeric keypad; other brokers' numbers can be
// alphanumeric, so leave the normal text keyboard.
export function hawbInputMode(job) {
  return hawbLabel(job) === "Receipt No." ? "numeric" : "text";
}
